import './main.less';
import React from 'react';
import PropTypes from 'prop-types';

class Main extends React.Component {
	constructor(props) {
		super(props);
		this.setWrapperRef = this.setWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.handleEscButtonPress = this.handleEscButtonPress.bind(this);
	}
	setWrapperRef(node) {
		this.wrapperRef = node;
	}
	handleClickOutside(event) {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.props.hideTermsPopup();
		}
	}
	handleEscButtonPress(e) {
		e.key == 'Escape' && (this.props.hideTermsPopup());
	}
	componentDidMount() {
		document.addEventListener('click', this.handleClickOutside);
		document.addEventListener('keydown', this.handleEscButtonPress);
	}
	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleEscButtonPress);
		document.removeEventListener('click', this.handleClickOutside);
	}
	render() {
		const { intl } = this.props;
		return (
			<div className='popup_container'>
				<div className="modal-overlay">
					<div className="popup-terms"
						ref={this.setWrapperRef}
					>
						<h2 className="">{intl('Rules of affiliate program')}</h2>
						<div className="modal-text">
							<ol className="terms-list">
								{termsListEn.map((term, index) => (
									<li key={index}>{intl(term)}</li>
								))}
							</ol>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
const termsListEn = [
	'market-rules:rule-1',
	'market-rules:rule-2',
	'market-rules:rule-3',
	'market-rules:rule-4',
	'market-rules:rule-5',
	'market-rules:rule-6',
	'market-rules:rule-7',
	'market-rules:rule-8',
	'market-rules:rule-9',
	'market-rules:rule-10',
	'market-rules:rule-11'
];

Main.propTypes = {
	intl: PropTypes.func,
	isTermsPopupShowed: PropTypes.bool,
	hideTermsPopup: PropTypes.func,
	togglePopup: PropTypes.func
};

export default Main;


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/terms-popup/main.js